var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-full text-xs"},[_c('LayoutHeader',[_vm._v(" Package Settings ")]),_c('LayoutContent',[_c('SiteDiscovery',{attrs:{"app":_vm.app}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }